import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { NbThemeService, NbColorHelper } from '@nebular/theme';


@Component({
  selector: 'ngx-chartjs-bar',
  template: `
    <chart type="bar"
           [data]="data"
           [options]="options"></chart>
  `,
})
export class ChartjsBarComponent implements OnDestroy, OnInit {
  @Input() data: any;
  @Input() options: any = {x: '', y: ''};
  themeSubscription: any;
  xlabel = "";
  ylabel = "";


  ngOnInit(): void {

    this.xlabel = this.options.x;
    this.ylabel = this.options.y;


    this.themeSubscription = this.theme.getJsTheme().subscribe(config => {


      const colors: any = config.variables;
      const chartjs: any = config.variables.chartjs;


      this.options = {
        maintainAspectRatio: true,
        responsive: true,
        legend: {
          labels: {
            fontColor: 'black'
          },
        },
        scales: {
          xAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: this.xlabel,
              },
              gridLines: {
                display: false,
                color: '#ededed',
              },
              ticks: {
                fontColor: "black",
              },
            },
          ],
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: this.ylabel,
              },
              gridLines: {
                display: true,
                color: '#ededed',
              },
              ticks: {
                fontColor: 'black'
              },
            },
          ],
        },
      };
    });
  }


  constructor(private theme: NbThemeService) {


  }



  ngOnDestroy(): void {
    this.themeSubscription.unsubscribe();
  }


}
